import { render, staticRenderFns } from "./DemoConfirmation.vue?vue&type=template&id=2a727cf2&scoped=true&"
import script from "./DemoConfirmation.vue?vue&type=script&lang=js&"
export * from "./DemoConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DemoConfirmation.vue?vue&type=style&index=0&id=2a727cf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a727cf2",
  null
  
)

export default component.exports